import React, {useMemo} from 'react';
import {getDispatch} from "../../../Utility/ReduxHelper";
import {showSaveCart} from "../../../ReduxStore/ShoppingCart/saveCartSlice";
import {getClassList} from "../../../Utility/siteConfig";
import {SECONDARY_CHECKOUT_BUTTON_CLASSES} from "../../constants";
import {useNonEmptyContext} from "../../../lib/hooks";
import {CartConfigContext} from "../../../contexts/CartConfigContext";

export default function SaveCartButton({shoppingCart = {}}) {
  const cartConfig = useNonEmptyContext(CartConfigContext);
  const saveCartConfig = useMemo(() => cartConfig.saveCart || {}, [cartConfig]);

  if (saveCartConfig?.disabled)
    return null;

  const handleClick = e => {
    const dispatch = getDispatch();
    console.log(`showSaveCart invoked, d=${typeof dispatch}`);

    dispatch(showSaveCart({flavour: 'requested'}));
  }

  const className = getClassList({
    key: 'CheckoutButton.common',
    fallback: SECONDARY_CHECKOUT_BUTTON_CLASSES
  })

  const iconClass = shoppingCart.savedAt ?
    'far fa-check-circle mr-2' :
    'far fa-shopping-cart mr-2';

  return (
    <div>
      <button className={className} type="button"
        onClick={handleClick}>
        <span className={iconClass}/>
        Save Your Cart
      </button>
    </div>
  );
}
